import { render, staticRenderFns } from "./CisternaPrimariaLeftSidebar.vue?vue&type=template&id=61c66aa8&"
import script from "./CisternaPrimariaLeftSidebar.vue?vue&type=script&lang=js&"
export * from "./CisternaPrimariaLeftSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CisternaPrimariaLeftSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports